import { type ReactNode, useState } from 'react'

import { ButtonDefault } from '@/components/common/Button'
import { InputColorWheel } from '@/components/common/Input'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { COLOR_ID_LABELS, COLOR_IDS, type ColorType } from '@/defs/mtg'
import { type RouteSectionType } from '@/defs/route'
import { useLinkInternal } from '@/hooks/useLinkInternal'
import { getColorId } from '@/utils/cardUtil'
import { cn } from '@/utils/commonUtil'

import styles from './HomeStartedBrowse.module.scss'

export const HomeStartedBrowse = () => {
  const { buildRelative } = useLinkInternal()
  const [colors, setColors] = useState<ColorType[]>([])

  const colorId = colors.length > 0 ? getColorId(colors) : false

  const chosenLinks: { label: ReactNode; section: RouteSectionType }[] = [
    {
      label: 'Cards',
      section: 'top',
    },
    {
      label: 'Commanders',
      section: 'commandersList',
    },
    {
      label: 'Mana Rocks',
      section: 'manaRocks',
    },
    {
      label: 'Lands',
      section: 'landsList',
    },
  ]

  return (
    <div className={styles.container}>
      <div className={styles.chooser}>
        <InputColorWheel colors={colors} onChange={setColors} />
      </div>
      <div className={styles.message}>
        <div
          className={cn(styles.messageSection, {
            isSelected: colorId === false,
            styles,
          })}
        >
          <div className={styles.header}>Choose a Color Identity</div>
          <p className={styles.subheader}>Use the icons to select your favorite color identity!</p>
        </div>
        {COLOR_IDS.map((ci) => (
          <div
            className={cn(styles.messageSection, {
              isSelected: ci === colorId,
              styles,
            })}
            key={ci}
          >
            <div className={styles.header}>
              <IconWithLabel iconBefore={COLOR_ID_LABELS[ci].icon}>{COLOR_ID_LABELS[ci].label}</IconWithLabel>
            </div>
            <p className={styles.subheader}>
              Check out these resources for <strong>{COLOR_ID_LABELS[ci].label}</strong> decks!
            </p>
            <div className={styles.links}>
              {chosenLinks.map(({ label, section }, i) => (
                <ButtonDefault as='LinkRoute' href={buildRelative({ colorId: ci, section })} key={i}>
                  <IconWithLabel iconBefore={COLOR_ID_LABELS[ci].icon}>{label}</IconWithLabel>
                </ButtonDefault>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
